import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../data";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-[#0A0C10] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="mb-16 max-w-2xl">
          <div className="text-[11px] uppercase tracking-[0.24em] text-[#00F0FF] mb-5">
            / Client reviews
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-white tracking-tighter leading-[1.05]">
            Londoners who trust us with{" "}
            <span className="text-gradient-cyan">their cars.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {TESTIMONIALS.map((t, i) => (
            <blockquote
              key={i}
              data-testid={`testimonial-${i}`}
              className="card-glow bg-[#12141C] border border-white/5 rounded-sm p-7 flex flex-col"
            >
              <Quote className="h-6 w-6 text-[#00F0FF]/60 mb-5" />
              <p className="text-sm text-white/85 leading-relaxed flex-1">
                "{t.text}"
              </p>
              <div className="mt-6 flex items-center justify-between border-t border-white/5 pt-5">
                <div>
                  <div className="font-heading text-white font-medium text-sm">
                    {t.name}
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-white/40 mt-1">
                    {t.car}
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <Star
                      key={idx}
                      className="h-3.5 w-3.5 fill-[#00F0FF] text-[#00F0FF]"
                    />
                  ))}
                </div>
              </div>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
